<template>
    <v-img src="/images/store.png" alt="" />
</template>

<script>
export default {};
</script>